import { render, staticRenderFns } from "./AnnouncementsList.vue?vue&type=template&id=41f18d19&scoped=true&"
import script from "./AnnouncementsList.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsList.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsList.vue?vue&type=style&index=0&id=41f18d19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f18d19",
  null
  
)

export default component.exports